import React from 'react';
import { IonChip, IonIcon, IonLabel } from '@ionic/react';
import { close } from 'ionicons/icons';

export interface FilterOption {
  key: string;
  label: string;
  value: string;
  color?: string;
}

export interface FilterGroup {
  name: string;
  options: FilterOption[];
}

interface FilterBarProps {
  groups: FilterGroup[];
  activeFilters: Record<string, string>;
  onFilterChange: (key: string, value: string | undefined) => void;
  onClearAll?: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  groups,
  activeFilters,
  onFilterChange,
  onClearAll,
}) => {
  const hasActiveFilters = Object.keys(activeFilters).length > 0;

  return (
    <div style={{ padding: '0 16px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
      {groups.map((group) => (
        <React.Fragment key={group.name}>
          {group.options.map((option) => {
            const isActive = activeFilters[option.key] === option.value;
            return (
              <IonChip
                key={`${option.key}-${option.value}`}
                color={isActive ? (option.color ?? 'primary') : 'medium'}
                outline={!isActive}
                onClick={() =>
                  onFilterChange(
                    option.key,
                    isActive ? undefined : option.value,
                  )
                }
                style={{ marginRight: '4px' }}
              >
                <IonLabel>{option.label}</IonLabel>
                {isActive && (
                  <IonIcon icon={close} />
                )}
              </IonChip>
            );
          })}
        </React.Fragment>
      ))}

      {hasActiveFilters && onClearAll && (
        <IonChip color="danger" outline onClick={onClearAll}>
          <IonIcon icon={close} />
          <IonLabel>Șterge tot</IonLabel>
        </IonChip>
      )}
    </div>
  );
};

export default FilterBar;
